import axios from 'axios'
export async function GetAllowedFileExtensions () {
  const fileextensions = await axios.get(`${window.apiConfig.APIURL}api/documents/alloweduploadfileextensions`, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
  return fileextensions
}
export function PostDocument (ownerType, taskId, formdata) {
  if (!taskId) {
    return
  }
  return axios.post(`${window.apiConfig.APIURL}api/documents/${ownerType}/${taskId}`, formdata, {
    headers: {
      'Content-Type': 'multipart/form-data',
      // "Content-Type": "application/json; charset=utf-8",
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}
export async function Register (json) {
  return axios.put(`${window.apiConfig.APIURL}api/users`, JSON.stringify(json), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}
